/**
 * Re-check the location account password before a full-device sign-out.
 * Shared kiosk tablets must not fully log out on a stray tap — only someone
 * who knows the location password can eject the device session.
 */

import { supabase } from '@/integrations/supabase/client';

export async function verifyLocationPassword(email: string, password: string): Promise<void> {
  if (!email.trim()) {
    throw new Error('No signed-in account email — cannot verify password.');
  }
  if (!password) {
    throw new Error('Enter the location password.');
  }

  const { error } = await supabase.auth.signInWithPassword({
    email: email.trim(),
    password,
  });

  if (error) {
    // Prefer GoTrue error_code (stable); fall back to English message substrings
    // for older clients that only surface `message`.
    const code = (error as { code?: string }).code?.toLowerCase()
      ?? (error as { error_code?: string }).error_code?.toLowerCase()
      ?? '';
    const msg = error.message?.toLowerCase() ?? '';
    if (
      code === 'invalid_credentials'
      || msg.includes('invalid')
      || msg.includes('credentials')
      || msg.includes('invalid login')
    ) {
      throw new Error('Wrong password.');
    }
    throw new Error(error.message || 'Password check failed — try again.');
  }
}
